import { useTranslation } from 'react-i18next';

import { isTranslatedLocale } from '~/features/catalog/utils/catalog-locale';

export function useI18n() {
  const { t, i18n } = useTranslation();
  const isRtl = i18n.dir() === 'rtl';
  const isEnUS = i18n.language === 'en-US';
  // True when the current language has maintained catalog/PLP translations.
  const isTranslated = isTranslatedLocale(i18n.language);

  return { t, i18n, isRtl, isEnUS, isTranslated };
}
